import { SidebarToggleIcon } from "../icons/SidebarToggleIcon"
import style from "./ElevationReferencesToggle.module.scss"

const { toggleButton, toggleButtonText, toggleButtonBottom } = style

type Props = {
	onOpen: () => void
	placement?: "top" | "bottom"
}

export const ElevationReferencesToggle = ({ onOpen, placement = "top" }: Props) => {
	return (
		<button
			className={`${toggleButton} ${placement === "bottom" ? toggleButtonBottom : ""}`}
			onClick={onOpen}
		>
			<span className={toggleButtonText}>Elevation references</span>
			<SidebarToggleIcon />
		</button>
	)
}
